import * as React from 'react';

export type PasswordRequirements = {
  isComplex: boolean;
  minLength: number;
};

export enum PasswordValidationKey {
  Required = 'required',
  InvalidLength = 'invalidLength',
  InvalidFormat = 'invalidFormat',
  OneUpperCase = 'oneUpperCase',
  OneLowerCase = 'oneLowerCase',
  OneNumber = 'oneNumber',
  OneSymbol = 'oneSymbol',
  PartOfEmail = 'partOfEmail'
}

export type PasswordValidations = {
  name: PasswordValidationKey;
  getLabel: (data: { minLength: number }) => string;
  isValid: (data: {
    value: string;
    email: string;
    passwordRequirements: PasswordRequirements;
  }) => boolean;
}[];

interface BaseProps extends React.InputHTMLAttributes<HTMLInputElement> {
  'data-variant'?: 'error' | 'disabled';
  'data-stretch'?: boolean;
  label: React.ReactNode;
  name: string;
}

export interface PasswordFieldProps extends BaseProps {
  value?: string;
  validationFunc?: (value: string) => PasswordValidationKey | void;
  onChangeValue?: (value: string, metadata: { invalidKey?: string }) => void;
}
